import { CommonModule, DatePipe } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { NbSecurityModule } from '@nebular/security';
import { NbIconModule, NbSelectModule } from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { MaterialModule } from '../material/material.module';
import { SurveyService } from '../satisfaction/services/survey.service';
import { DefButtonComponent } from './components/def-button/def-button.component';
import { DefFormErrorsComponent } from './components/def-form-errors/def-form-errors.component';
import { DefIconLabelComponent } from './components/def-icon-label/def-icon-label.component';
import { DefLoaderComponent } from './components/def-loader/def-loader.component';
import { DefMenuBurgerComponent } from './components/def-menu-burger/def-menu-burger.component';
import { DefMenuTabsComponent } from './components/def-menu-tabs/def-menu-tabs.component';
import { DefMobileSearchBarComponent } from './components/def-mobile-search-bar/def-mobile-search-bar.component';
import { DefProfilPictureComponent } from './components/def-profil-picture/def-profil-picture.component';
import { DefProfileSheetComponent } from './components/def-profile-sheet/def-profile-sheet.component';
import { DefRegistrationTableComponent } from './components/def-registration-table/def-registration-table.component';
import { DefSearchBarComponent } from './components/def-search-bar/def-search-bar.component';
import { DefServicesHealthCheckComponent } from './components/def-services-health-check/def-services-health-check.component';
import { DefSheetsComponent } from './components/def-sheets/def-sheets.component';
import { DefSideTabsComponent } from './components/def-side-tabs/def-side-tabs.component';
import { DefSpinnerCheckComponent } from './components/def-spinner-check/def-spinner-check.component';
import { DefSpritesComponent } from './components/def-sprites/def-sprites.component';
import { DefStarRatingComponent } from './components/def-star-rating/def-star-rating.component';
import { DefTimepickerComponent } from './components/def-timepicker/def-timepicker.component';
import { MiscellaneousComponent } from './components/miscellaneous/miscellaneous.component';
import { ReportIssuesComponent } from './components/report-issues/report-issues.component';
import { RoomBookingTableComponent } from './components/room-booking-table/room-booking-table.component';
import { SatisfactionPopupComponent } from './components/satisfaction-popup/satisfaction-popup.component';
import { StarGroupComponent } from './components/star-group/def-star-group.component';
import { UnregistrationConfirmationComponent } from './components/unregistration-confirmation/unregistration-confirmation.component';
import { DragDropDirective } from './directives/drag-drop.directive';
import { DefImageErrorDirective } from './directives/image-error.directive';
import { DefScrollToDirective } from './directives/scroll-to.directive';
import { TrackEventDirective } from './directives/track-event.directive';
import { AcademyLanguagePipe } from './pipes/academy-language.pipe';
import { DefCleanCourseContentPipe } from './pipes/clean-course-name.pipe';
import { DefCurrencySymbolPipe } from './pipes/def-currency-symbol.pipe';
import { NeutralizeCountryNamePipe } from './pipes/def-neutralize-country-name.pipe';
import { DefTruncateTextPipe } from './pipes/def-truncate-text.pipe';
import { DurationPipe } from './pipes/duration.pipe';
import { LanguagePipe } from './pipes/language.pipe';
import { MemberEmailPipe } from './pipes/member-email.pipe';
import { DefMemberNamePipe } from './pipes/member-name.pipe';
import { CourseInstanceService } from './services/training/course-instance.service';
import { CourseService } from './services/training/course.service';
import { ExchangeApiService } from './services/exchange-api.service';
import { HealthCheckService } from './services/health-check.service';
import { MemberService } from './services/member.service';
import { RegistrationService } from './services/training/registration.service';
import { RoomBookingService } from './services/booking/room-booking.service';
import { SortingService } from './services/sorting.service';
import { SurveyTopicService } from './services/survey-topic.service';
import { AnalyticsService } from './services/utils/analytics.service';

export const SHARED_PROVIDERS = [
  ExchangeApiService,
  SortingService,
  RoomBookingService,
  CourseInstanceService,
  RegistrationService,
  DatePipe,
  SurveyService,
  HealthCheckService,
  CourseService,
  MemberService,
  AnalyticsService,
  DefMemberNamePipe,
  SurveyTopicService,
];

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule,
    NgxMaterialTimepickerModule,
    RouterModule,
    TranslateModule,
    MatTableModule,
    NbSelectModule,
    NbIconModule,
    MatBottomSheetModule,
    NbSecurityModule,
  ],
  declarations: [
    DefIconLabelComponent,
    DefButtonComponent,
    DefProfilPictureComponent,
    DefStarRatingComponent,
    StarGroupComponent,
    DefSheetsComponent,
    DefMenuTabsComponent,
    DefSearchBarComponent,
    DefTimepickerComponent,
    DefSpritesComponent,
    DefLoaderComponent,
    DefCurrencySymbolPipe,
    DefProfileSheetComponent,
    LanguagePipe,
    DefScrollToDirective,
    DefImageErrorDirective,
    DragDropDirective,
    DefMobileSearchBarComponent,
    MiscellaneousComponent,
    DefSpinnerCheckComponent,
    SatisfactionPopupComponent,
    DefMenuBurgerComponent,
    DefTruncateTextPipe,
    DefSideTabsComponent,
    DefServicesHealthCheckComponent,
    TrackEventDirective,
    DefFormErrorsComponent,
    DefRegistrationTableComponent,
    DefMemberNamePipe,
    RoomBookingTableComponent,
    DefMemberNamePipe,
    MemberEmailPipe,
    DefCleanCourseContentPipe,
    ReportIssuesComponent,
    NeutralizeCountryNamePipe,
    AcademyLanguagePipe,
    UnregistrationConfirmationComponent,
    DurationPipe,
  ],
  providers: [],
  exports: [
    TranslateModule,
    DefIconLabelComponent,
    DefButtonComponent,
    DefProfilPictureComponent,
    DefStarRatingComponent,
    StarGroupComponent,
    DefSheetsComponent,
    DefMenuTabsComponent,
    DefSearchBarComponent,
    DefTimepickerComponent,
    DefSpritesComponent,
    DefLoaderComponent,
    DefCurrencySymbolPipe,
    DefProfileSheetComponent,
    LanguagePipe,
    DefScrollToDirective,
    DefImageErrorDirective,
    DragDropDirective,
    DefMobileSearchBarComponent,
    MiscellaneousComponent,
    DefMenuBurgerComponent,
    DefTruncateTextPipe,
    DefSideTabsComponent,
    DefServicesHealthCheckComponent,
    TrackEventDirective,
    DefFormErrorsComponent,
    DefRegistrationTableComponent,
    RoomBookingTableComponent,
    DefMemberNamePipe,
    MemberEmailPipe,
    DefCleanCourseContentPipe,
    NeutralizeCountryNamePipe,
    ReportIssuesComponent,
    AcademyLanguagePipe,
    DurationPipe,
  ],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: SHARED_PROVIDERS,
    } as ModuleWithProviders<SharedModule>;
  }
}
